var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6276 23.4549C16.1526 23.2087 16.488 22.6813 16.488 22.1007L16.4884 1.8898C16.4884 1.30959 16.1526 0.781794 15.628 0.535608C15.1034 0.287652 14.4835 0.366644 14.0365 0.737162L6 7.39651V16.5936L14.0361 23.2527C14.3099 23.4797 14.6489 23.5973 14.9911 23.5973C15.2072 23.5973 15.4247 23.5509 15.6276 23.4549ZM5 16.4728V7.51699H1.49659C0.670191 7.51699 0 8.18719 0 9.01394V14.9766C0 15.803 0.670191 16.4735 1.49659 16.4728H5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1323 19.7662C21.1684 19.7662 21.2035 19.7648 21.24 19.7623C21.6732 19.7315 22.0713 19.5133 22.3317 19.1658C23.8903 17.0808 24.7139 14.6012 24.7139 11.9963C24.7139 9.19934 23.7826 6.58022 22.0196 4.423C21.7518 4.09569 21.3576 3.89697 20.9354 3.87572C20.5018 3.84986 20.1012 4.01281 19.8022 4.31177L19.6024 4.5119C19.0601 5.05387 19.0155 5.91817 19.4993 6.51327C20.7703 8.07893 21.4419 9.97474 21.4419 11.9959C21.4419 13.8751 20.8503 15.6664 19.7296 17.1775C19.2875 17.7733 19.3491 18.6033 19.8741 19.1272L20.0742 19.328C20.3558 19.61 20.737 19.7662 21.1323 19.7662Z",
    stroke: "white",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.22e0d1180858f88c99e1823d5f91c5a7.svg";
export { ForwardRef as ReactComponent };